import React from 'react';

import { AsyncBetslipFreebet } from 'modules/freebet/async';
import BetslipStakeInput from '../../BetslipStakeInput';
import Error from '../../Error';
import TotalRow from '../TotalRow';
import useExpressPart from './useExpressPart';

import './expressPart.scss';

interface Props {
    betslipBetId: string;
}

const ExpressPart: React.FC<Props> = ({ betslipBetId }) => {
    const props = useExpressPart({ betslipBetId });

    if (!props) return null;

    const {
        errorMsgs,
        changeStakeHandler,
        stake,
        maxStake,
        isFreebetSelected,
        formattedTotalOdd,
        isDecimal,
        toggleFreeBetHandler,
        betslipOddIds,
        betType,
        isSuspended,
        totals: { totalStake, totalWin },
        onKeyDown,
    } = props;

    return (
        <div styleName="container">
            {errorMsgs.length > 0 && <Error messages={errorMsgs} />}
            <AsyncBetslipFreebet
                toggleFreebetCallback={toggleFreeBetHandler}
                betslipOddIds={betslipOddIds}
                betType={betType}
                isFreebetInProcess={isSuspended}
            />
            {!isFreebetSelected && (
                <BetslipStakeInput
                    maxStake={maxStake}
                    isDisabled={isFreebetSelected}
                    changeValue={changeStakeHandler}
                    value={stake}
                    onKeyDown={onKeyDown}
                />
            )}
            <TotalRow
                totalStake={totalStake}
                betslipBetId={betslipBetId}
                totalOdd={formattedTotalOdd}
                withPlus={isDecimal}
                totalPotentialWin={totalWin}
                isFreebetSelected={isFreebetSelected}
            />
        </div>
    );
};

export default React.memo(ExpressPart);
